import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from "@angular/router";

import { Observable, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { DffSimpelDialog } from "@dffedb/ui";
import { EntitetStatus } from "@dffedb/util";
import { FeatureNoterComponent } from "@e-forsyning/features/noter";

@Injectable({
    providedIn: "root"
})
export class FeatureNoterGuard implements CanDeactivate<FeatureNoterComponent> {
    constructor(private readonly dialog: DffSimpelDialog) {}

    public canDeactivate(
        component: FeatureNoterComponent,
        _currentRoute: ActivatedRouteSnapshot,
        _currentState: RouterStateSnapshot,
        _nextState?: RouterStateSnapshot
    ): Observable<boolean> {
        return component.vm$.pipe(
            map(vm => vm.data.formArray.controls.some(c => c.get("status").value !== EntitetStatus.Uaendret)),
            // Har man forvildet sig over på noter uden en aktiv installation, kan det være svært at komme derfra igen
            catchError(() => of(false)),
            switchMap(modified =>
                modified
                    ? this.dialog.openJaNej(
                          "Vil du annullere ændringer?",
                          "Du har ugemte ændringer. Er du sikker på, du ønsker at forlade siden?"
                      )
                    : of(true)
            )
        );
    }
}
